// dbext:profile=staging_mcdo2019_be
import $ from "jquery";
import admin_crud from "./910-admin_crud.js";

export default {
init()
    {
        if ( $('.c-admin-restaurants-scheduled-tasks-overview' ).length > 0 ){
            this._init();
        }
    },

    _init()
    {
        $('.js-task-delete-button').on( 'click', this.on__task_delete_button__click() );
    },

    on__task_delete_button__click()
    {
        return async ( e ) => {
            e.preventDefault();

            $( '.js-task-delete-button' ).addClass( 'disabled' );

            // not sure?
            if ( ! window.confirm( 'Are you sure?' ) ){
                $( '.js-task-delete-button' ).removeClass( 'disabled' );
                return;
            }

            // get necessary data
            let de_clicked = $(e.target);
            let de_row     = de_clicked.closest('tr');
            let task_id    = de_row.find('.js-id').data('id');

            // delete task in database
            let status = await this.delete_task( task_id );
            if ( ! status ){
                alert('ERROR: something went wrong, please refresh this pagae');
                return;
            }

            // deleting effect frontend
            de_clicked.remove();
            de_row.css('background-color', 'black');
            de_row.fadeOut( 400, function(){
                de_row.remove();
                $( '.js-task-delete-button' ).removeClass( 'disabled' );

                // no more tasks to delete? ⇒ refresh page
                if ( $( '.js-task-delete-button' ).length === 0 ){
                    location.reload();
                }
            } );
        };
    },

/*

    select *
    from 211_openinghours_schedule

*/

    async delete_task( task_id )
    {

        let response = await
        admin_crud.POST( admin_crud.posturl( '211_openinghours_schedule', 'delete' ), {
            ids : {
                id : task_id,
            },
        } );

        let http_status = response.status;
        if ( typeof http_status === 'number' ){
            http_status = http_status.toString();
        }

        return ( http_status === '200' );
    },

}


